export const generateLink = (route: string, language: string) => {
  return language === "en" ? route : `/${language}${route}`;
};

export const generateRedirectUrl = (
  baseUrl: string,
  language: string
): string => {
  return language === "en" ? baseUrl : `${baseUrl}/${language}`;
};
